<template>
    <v-dialog v-model="shows" max-width="900" persistent>
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-if="isLoaded" height="100%">
            <v-card-title>
                <template v-if="isCreate">프로그램 생성</template>
                <template v-else>프로그램 상세</template>
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="pa-0">
                <v-row no-gutters>
                    <v-col cols="12" sm="5">
                        <v-card-subtitle>썸네일</v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-preview-input v-model="inputs.thumb" :aspect-ratio="1 / 1" />
                        </v-card-text>
                    </v-col>
                    <v-col cols="12" sm="auto">
                        <v-divider v-show="!isMobile" vertical />
                        <v-divider v-show="isMobile" />
                    </v-col>
                    <v-col>
                        <v-card-subtitle>기본 정보</v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col class="mr-3">
                                    <v-select label="유형" v-model="inputs.hall" :items="items_hall" v-bind="attrs_input" />
                                </v-col>
                                <v-col> </v-col>
                            </v-row>
                            <v-text-field label="프로그램 제목" v-model="inputs.subject" v-bind="attrs_input" class="my-3" />
                            <row-date-time label="일시" v-model="inputs.at" :attrs_input="attrs_input" />
                            <row-date-time label="기간-시작" v-model="inputs.duration.startsAt" :attrs_input="attrs_input" />
                            <row-date-time label="기간-종료" v-model="inputs.duration.endsAt" :attrs_input="attrs_input" />
                            <v-text-field label="장소" v-model="inputs.location" v-bind="attrs_input" class="my-3" />
                            <v-combobox label="그룹" placeholder="Tab을 누르면 항목이 추가됩니다" v-model="inputs.groups" v-bind="attrs_input" multiple small-chips>
                                <template v-slot:selection="{ attrs, item, parent }">
                                    <v-chip v-bind="attrs" small text-color="grey darken-4">
                                        <span class="pr-2"> {{ item }} </span>
                                        <v-icon small @click="parent.selectItem(item)"> $delete </v-icon>
                                    </v-chip>
                                </template>
                            </v-combobox>
                        </v-card-text>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn large color="primary" @click="save"> 저장하기 </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import RowDateTime from "../dumb/row-date-time.vue";
import VPreviewInput from "@/components/plugins/vuetify/v-preview-input.vue";

import api from "@/api";
import detect from "@/plugins/detect";
import { attrs_input, AUCTION_PROGRAM_HALLS } from "@/assets/variables";

const makeProgram = () => ({
    thumb: null,

    hall: null,

    subject: null,
    content: null,

    groups: [],

    at: null,
    duration: {
        startsAt: null,
        endsAt: null,
    },

    location: null,
});

export default {
    components: {
        RowDateTime,
        VPreviewInput,
    },
    props: {
        value: { type: Object },
    },
    data: () => ({
        shows: false,
        isLoaded: false,
        inputs: {},

        items_hall: Object.values(AUCTION_PROGRAM_HALLS),

        attrs_input,
        isMobile: detect == "mobile",
    }),
    computed: {
        _program() {
            return this.value?._id;
        },
        isCreate() {
            return !this._program;
        },
    },
    methods: {
        async init() {
            this.isLoaded = false;
            if (this.isCreate) {
                this.inputs = { ...makeProgram() };
            } else {
                const { program } = await api.console.auction.programs.get({ _id: this._program });
                if (program.thumb) program.thumb = await api.getResource(program.thumb.url);
                this.inputs = program;
            }
            this.isLoaded = true;
        },

        validate() {},

        async save() {
            try {
                this.validate();

                const { _thumb, thumb, ...inputs } = this.inputs;

                // Document POST / PUT
                let program;
                if (this.isCreate) [program] = [(await api.console.auction.programs.post(inputs))?.program];
                else [program] = [(await api.console.auction.programs.put(inputs))?.program];

                // Files POST / PUT
                if (_thumb) await api.console.auction.files.delete({ _id: _thumb });
                if (thumb) {
                    const { file } = await api.console.auction.files.post({ _program: program._id, index: "thumb" }, thumb);

                    program._thumb = file._id;
                    [program] = [(await api.console.auction.programs.put(program))?.program];
                    program.thumb = file;
                }

                alert("저장되었습니다");
                this.$emit("input", program);
                this.shows = false;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>
